// external libraries goes here for separate webpack bundling

// Angular
import '@angular/platform-browser'
import '@angular/platform-browser-dynamic'
import '@angular/core'
import '@angular/common'
import '@angular/http'
import '@angular/forms'
import '@angular/router'

// RxJS
import 'rxjs'

// Other vendors for example jQuery, Lodash or Bootstrap
// You can import js, ts, css, sass, ...



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./vendor.ts